<template>
  <div :visible="false">
    <input
      :id="inputId"
      v-model="checked"
      :visible="false"
      type="checkbox"
      :style="style"
      :name="name"
      @change="
        emit('update:model-value', checked);
        emit('input', checked);
      "
    />
  </div>
</template>

<script setup lang="ts" generic="T extends any">
import { ref } from "vue";

const props = defineProps<{
  inputId?: string;
  modelValue?: boolean;
  value?: T;
  name?: string;
  style: string;
}>();

const emit = defineEmits<{
  (e: "input", val: boolean): void;
  (e: "update:model-value", val: boolean): void;
}>();

const checked = ref(props.modelValue);
</script>

<style scoped>
input {
  accent-color: var(--activeColor);
  width: 20px;
  height: 20px;
  cursor: pointer;
  background-color: var(--activeColor);
}
</style>
